<template>
  <article class="wagb-old">
    <div class="wagb-old__lead">
      <!-- 导语 -->
      <div class="wagb-old__intro">
        <p>
          {{ intro.paragraph.textBefore
          }}<router-link :to="intro.paragraph.linkTo">{{ intro.paragraph.linkText }}</router-link
          >{{ intro.paragraph.textAfter }}
        </p>
        <p class="wagb-old__note">
          👉 Saat ini versi terbaru yang tersedia adalah <strong>{{ intro.latestVersion }}</strong>, namun kamu tetap
          bisa memilih versi lama sesuai kebutuhan perangkat dan preferensi penggunaan.
        </p>
      </div>

      <router-link :to="intro.ctaLink" class="wagb-old__cta">
        👉 {{ intro.cta }}
      </router-link>
    </div>

    <!-- Kenapa Memilih Versi Lama -->
    <section :id="sections.whyOld.id" class="wagb-old__section wagb-old__section--why">
      <h2>{{ sections.whyOld.title }}</h2>
      <p>{{ sections.whyOld.intro }}</p>
      <ul class="wagb-old__list wagb-old__list--reasons">
        <li v-for="item in sections.whyOld.items" :key="item">{{ item }}</li>
      </ul>
    </section>

    <!-- Daftar WA GB Versi Lama -->
    <section :id="sections.versionList.id" class="wagb-old__section wagb-old__section--versions">
      <h2>{{ sections.versionList.title }}</h2>
      <p>{{ sections.versionList.intro }}</p>

      <!-- UI 效果贴图：版本卡片，纯 CSS 构建，非 content 图片 -->
      <div class="wagb-old__version-grid">
        <article
          v-for="(card, index) in sections.versionList.cards"
          :key="card.version"
          class="wagb-old__ui-card"
          :class="'wagb-old__ui-card--' + (index + 1)"
          :data-ver="card.version"
        >
          <h3>{{ card.title }}</h3>
          <p>{{ card.desc }}</p>
          <router-link :to="card.ctaLink" class="wagb-old__card-btn">
            👉 {{ card.cta }}
          </router-link>
        </article>
      </div>
    </section>

    <!-- Kelebihan -->
    <section :id="sections.advantages.id" class="wagb-old__section wagb-old__section--advantages">
      <h2>{{ sections.advantages.title }}</h2>
      <ul class="wagb-old__list wagb-old__list--check">
        <li v-for="item in sections.advantages.items" :key="item">{{ item }}</li>
      </ul>
    </section>

    <!-- Catatan Penting -->
    <section :id="sections.notice.id" class="wagb-old__section">
      <h2>{{ sections.notice.title }}</h2>
      <div class="wagb-old__notice">
        <p>{{ sections.notice.text }}</p>
      </div>
    </section>

    <!-- Kesimpulan -->
    <section :id="sections.conclusion.id" class="wagb-old__section wagb-old__section--conclusion">
      <h2>{{ sections.conclusion.title }}</h2>
      <p>{{ sections.conclusion.text }}</p>
    </section>
  </article>
</template>

<script>
import '@/css/wagbappro-old-versions.scss';
import { intro, sections } from '@/data/wagbappro/old-versions-id';

export default {
  name: 'OldVersionsContentId',
  data() {
    return { intro, sections };
  },
};
</script>
